import {
  MAIN_COMPANY_FILTER,
  MAIN_SALESORG_FILTER,
  MAIN_CHANNEL_FILTER,
  MAIN_IMPORT_COMPANY_FILTER,
  MAIN_IMPORT_SALESORG_FILTER,
  MAIN_IMPORT_CHANNEL_FILTER,
  MAIN_DOCUMENT_TYPE_FILTER,
  KEYWORD_FILTER,
  START_DATE_FILTER,
  END_DATE_FILTER,
  DOC_STATUS_FILTER,
  EXPENSE_TYPE_FILTER,
  EXPENSE_TRANSACTION_STATUS_FILTER,
  MENU_NOTIFICATION_REFRESH,
} from "../constants/ActionTypes";

//Set default Start date (วันนี้)
let dt = new Date();
let startYear = dt.getFullYear();
let startintMonth = String(dt.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed, so add 1
let startintDay = String(dt.getDate()).padStart(2, "0"); // getDate() gives the day of the month

//Set default end date (วันปัจจุบัน)
let dt2 = new Date();
let endYear = dt2.getFullYear();
let endMonth = String(dt2.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed, so add 1
let endDay = String(dt2.getDate()).padStart(2, "0"); // getDate() gives the day of the month

let defaultStartDate = `${startYear}-${startintMonth}-${startintDay}`;
let defaultEndDate = `${endYear}-${endMonth}-${endDay}`;

const initialState = {
  companySelected: "",
  salesOrgSelected: "",
  channelSelected: "",
  companyImportSelected: "",
  salesOrgImportSelected: "",
  channelImportSelected: "",
  keywordFilter: "",
  startDateSelected: defaultStartDate,
  endDateSelected: defaultEndDate,
  docStatusSelected: "",
  documentTypeSelected: null,
  expenseTypeSelected: "",
  menuNotificationRefresh: 0,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case MAIN_COMPANY_FILTER:
      return {
        ...state,
        companySelected: action.payload,
      };
    case MAIN_SALESORG_FILTER:
      return {
        ...state,
        salesOrgSelected: action.payload,
      };
    case MAIN_CHANNEL_FILTER:
      return {
        ...state,
        channelSelected: action.payload,
      };
    case MAIN_IMPORT_COMPANY_FILTER:
      return {
        ...state,
        companyImportSelected: action.payload,
      };
    case MAIN_IMPORT_SALESORG_FILTER:
      return {
        ...state,
        salesOrgImportSelected: action.payload,
      };
    case MAIN_IMPORT_CHANNEL_FILTER:
      return {
        ...state,
        channelImportSelected: action.payload,
      };
    case KEYWORD_FILTER:
      return {
        ...state,
        keywordFilter: action.payload,
      };
    case START_DATE_FILTER:
      return {
        ...state,
        startDateSelected: action.payload,
      };
    case END_DATE_FILTER:
      return {
        ...state,
        endDateSelected: action.payload,
      };
    case DOC_STATUS_FILTER:
      return {
        ...state,
        docStatusSelected: action.payload,
      };
    case MAIN_DOCUMENT_TYPE_FILTER:
      return {
        ...state,
        documentTypeSelected: action.payload,
      };
    case EXPENSE_TYPE_FILTER:
      return {
        ...state,
        expenseTypeSelected: action.payload,
      };

      case EXPENSE_TRANSACTION_STATUS_FILTER:
      return {
        ...state,
        expenseTransactionStatusSelected: action.payload,
      };
    case MENU_NOTIFICATION_REFRESH:
      return {
        ...state,
        menuNotificationRefresh: state.menuNotificationRefresh + 1,
      };
    default:
      return state;
  }
};
